var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付ける先生を選択してください","resourceType":"teacher","fields":_vm.fields,"items":_vm.teacher.teachers,"totalItems":_vm.totalTeachers,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }